import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm$gettingHistories$, _vm$gettingHistories$2;
  var _vm = this,
    _c = _vm._self._c;
  return _c(VNavigationDrawer, {
    key: "history_".concat((_vm$gettingHistories$ = _vm.gettingHistories.items) === null || _vm$gettingHistories$ === void 0 ? void 0 : _vm$gettingHistories$.length),
    attrs: {
      fixed: "",
      bottom: "",
      right: "",
      width: "55%",
      temporary: ""
    },
    model: {
      value: _vm.isShown,
      callback: function callback($$v) {
        _vm.isShown = $$v;
      },
      expression: "isShown"
    }
  }, [_c("div", {
    staticClass: "drawer"
  }, [_c("section", {
    staticClass: "drawer-header"
  }, [_c("div", {
    staticClass: "drawer-title"
  }, [_c(VBtn, {
    staticClass: "primary",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.close
    }
  }, [_c(VIcon, {
    attrs: {
      dark: ""
    }
  }, [_vm._v("mdi-close")])], 1), _c("h2", [_vm._v(_vm._s(_vm.order.reference_order) + "'s history")])], 1)]), _c("div", [((_vm$gettingHistories$2 = _vm.gettingHistories.items) === null || _vm$gettingHistories$2 === void 0 ? void 0 : _vm$gettingHistories$2.length) > 0 ? [_c("div", {
    staticClass: "history-past"
  }, [_vm._v("Past 30 days up to the last 1,000 actions")]), _c("section", {
    staticClass: "history-container"
  }, [_vm.gettingHistories.isPending ? _c("div", {
    staticClass: "history-entry flex gap-2"
  }, [_c(VSkeletonLoader, {
    attrs: {
      width: "100%",
      type: "heading",
      title: "Loading new"
    }
  })], 1) : _vm._e(), _vm._l(_vm.gettingHistories.items, function (history) {
    return _c("div", {
      key: "history-" + history.timestamp,
      staticClass: "history-entry"
    }, [_c("span", {
      staticClass: "history-date"
    }, [_vm._v(_vm._s(_vm._f("formatDateTimeToLocal")(history.timestamp)))]), _c("span", {
      staticClass: "history-message",
      domProps: {
        innerHTML: _vm._s(_vm.boldQuotedText(history.message))
      }
    })]);
  })], 2)] : _vm.gettingHistories.isPending ? _c("section", {
    staticClass: "history-empty"
  }, [_vm._v("Loading ...")]) : _c("section", {
    staticClass: "history-empty"
  }, [_vm._v("No history in the last 30 days")])], 2)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };